import {useMutation} from 'react-query';
import {deleteDocumentImg} from './deleteDocumentImg';

const useDeleteDocumentImg = () => {
  const {mutate, isLoading, data} = useMutation({
    mutationFn: (imgGuid: string) => deleteDocumentImg(imgGuid),
  });

  return {mutate, isLoading, data};
};

export default useDeleteDocumentImg;
